import ThankYou from "./form/thank-you";

export const marketoFormSetup = (marketoFormId) => {
  const MarketoBaseURL = "//info.industriousoffice.com";
  const MarketoMunchkinId = "349-JNN-804";

  MktoForms2.loadForm(
    MarketoBaseURL,
    MarketoMunchkinId,
    marketoFormId,
    function (form) {
      // Sidebar form height should be set as var
      // banner--form
      const formInnerHeight = $("#js-sidebar-iframe-form").length
        ? $("#js-sidebar-iframe-form").innerHeight()
        : 640;

      const r = document.querySelector(":root");
      r.style.setProperty("--dl-form-height", formInnerHeight + "px");

      const ghostForm = document.querySelector(".js-ghost-form-select");

      if (ghostForm) {
        const options = ghostForm.querySelectorAll("option");

        const select = form
          .getFormElem()[0]
          .querySelector("#Select_Location__c");

        select.innerHTML = "";

        options.forEach((option) => {
          select.append(option);
        });

        select.value = "";
      }

      //Routing calendly on iframe forms
      const routingCalendlyWrapper = form
        .getFormElem()[0]
        .classList.contains("js-mkt-calendly");

      // Add form vals for each location
      if (form.getFormElem()[0].classList.contains("js-location-mkt-iframe")) {
        form.vals({
          Latest_Application_Toured_Location_ID__c: form.getFormElem()[0]
            .dataset.salesforce_id,
        });
      } else {
        form.getFormElem()[0].parentNode.style.minHeight =
          form.getFormElem()[0].parentNode.offsetHeight + "px";
      }

      if (
        document.querySelector(".js-iframe-calendly") &&
        document.querySelector(".js-iframe-calendly").dataset.routingCalendly
      ) {
        //Routing calendly on template-blocks iframe forms
        handleRoutingForm(form);
      } else {
        // Add an onSuccess handler
        form.onSuccess(function () {
          // Get the form's jQuery element and hide it
          form.getFormElem().hide();
          if (form) {
            const calendly = form.getFormElem()[0].nextElementSibling;
            document.body.classList.add("js-hide-modal");

            //Routing calendly on iframe forms
            // Hide modal
            if (routingCalendlyWrapper) {
              document.body.classList.add("js-hide-modal");
            }

            if (calendly && calendly.classList.contains("js-calendly")) {
              calendly.classList.remove("d-none");
            } else {
              ThankYou.init(form.getFormElem()[0]);
            }
          }

          return false;
        });
      }
    }
  );
};
//TODO: add calendly scripts //calendly.com/assets/external/widget.css and //calendly.com/assets/external/forms.js
function handleRoutingForm(form) {
  const calendly =
    "https://calendly.com/api/form_builder/forms/" +
    form.getFormElem().data("routing-calendly") +
    "/submissions";

  form.onSuccess((submittedValues) => {
    const { sfdcLeadId, ...values } = submittedValues;

    fetch(calendly, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...values,
        url_params: {
          salesforce_uuid: sfdcLeadId,
        },
      }),
    })
      .then((result) => result.json())
      .then((submission) => {
        const { result_type: resultType, result_url: resultUrl } = submission;

        if (resultType === "arbitrary_url") {
          return window.open(resultUrl, "_blank").focus();
        }
        // eslint-disable-next-line no-undef
        return Calendly.showPopupWidget(
          resultUrl + "?salesforce_uuid=" + sfdcLeadId
        );
      });

    return false;
  });
}

function handleIframeForms() {
  // Iframe marketo form for global book a tour element
  if (document.querySelectorAll(".js-mkto-form-iframe").length > 0) {
    document.querySelectorAll(".js-mkto-form-iframe").forEach((iframe) => {
      marketoFormSetup(iframe.getAttribute("data-form-id"));
    });
  }
}

export default handleIframeForms;
